import { Component, OnDestroy, OnInit } from "@angular/core";
import moment from "moment-timezone";
import { FileSaverService } from "ngx-filesaver";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOLink } from "src/app/shared/models/oo-link";
import { OOVenue } from "src/app/shared/models/oo-venue";
import * as uuid from "uuid";

@Component({
	selector: "app-link-key-setup",
	templateUrl: "./link-key-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class LinkKeySetupComponent implements OnInit, OnDestroy {
	baseUrl: string;
	bulkAdd: boolean = false;

	changesToSave: boolean = false;

	dHeader: string;
	dKey: string;
	dVisible: boolean = false;

	loaded: boolean = false;

	moment: any = moment;

	ooVenue: OOVenue;

	newLinkButtonModel = [
		{
			icon: "pi pi-plus",
			label: "Create a Link",
			command: () => {
				this.linkSelected = new OOLink({ venueKey: this.venueService.venueKey });
			},
		},
		{
			icon: "pi pi-bars",
			label: "Bulk Link Create",
			command: () => {
				this.bulkAdd = true;
			},
		},
	];
	newRecord: boolean = false;

	linkList: OOLink[];
	linkSelected: OOLink;
	linkListSubscription: Subscription = new Subscription();

	showPrintable: boolean = false;

	constructor(public app: AppService, private fileSaverService: FileSaverService, public venueService: OOVenueService) {}
	ngOnDestroy(): void {
		this.linkListSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.baseUrl = window.location.hostname;

		if (this.baseUrl === "localhost") {
			this.baseUrl = `http://localhost:4200`;
		} else if (this.baseUrl.includes("dev")) {
			this.baseUrl = "https://dev.onlineorder.focuspos.com";
		} else {
			this.baseUrl = "https://app.focuspos.com";
		}
		this.linkList = this.venueService.subscriptionOOlink.value;
		this.linkListSubscription.add(
			this.venueService.subscriptionOOlink.subscribe((data) => {
				this.linkList = [...data];
			})
		);
	}

	onAdd() {
		this.linkSelected = new OOLink({
			venueKey: this.venueService.subscriptionVenue.value.key,
		});
		this.bulkAdd = true;
	}

	async downloadFile(data: any) {
		data = data.map((d) => ({
			id: d.id,
			link: `${this.baseUrl}/${this.venueService.venueKey}?linkKey=${d.key}`,
		}));

		const replacer = (key, value) => (value === null ? "" : value);
		const header = Object.keys(data[0]);
		let csv = data.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(","));
		csv.unshift(header.join(","));
		let csvArray = csv.join("\r\n");

		var blob = new Blob([csvArray], { type: "text/csv" });
		this.fileSaverService.save(blob, "links.csv");
	}

	async linkDelete(idx: number) {
		const linkId = this.venueService.subscriptionOOlink.value[idx].id;
		this.venueService.ooLinkDelete(this.venueService.ooLinks[idx]);
		this.app.msgSvc.add({ severity: "success", detail: `Deleted ${linkId}` });
	}

	linkNew() {
		this.linkSelected = new OOLink({
			venueKey: this.venueService.venueKey,
		});
	}

	async linkAdd(linkKey: OOLink) {
		if (linkKey.id) {
			linkKey.id = linkKey.id.toString();
			const exists = this.venueService.ooLinks.some((l) => l.id.toLowerCase() === linkKey.id.toLowerCase());
			if (!exists) {
				this.venueService.ooLinkSave({
					key: uuid.v4(),
					venueKey: this.venueService.venueKey,
					id: this.linkSelected.id,
					orderType: this.linkSelected.orderType || undefined,
					menuKey: this.linkSelected.menuKey || undefined,
				});
				this.app.msgSvc.add({ severity: "success", detail: `Added ${this.linkSelected.id}` });
			}
		}
	}

	async linkAddBulk(linkStart: number, linkEnd: number, prefix?: string, menuKey?: string, orderTypeKey?: number) {
		const qty = linkEnd - linkStart;
		const newLinks: OOLink[] = [];
		for (let i = 0; i < qty + 1; i++) {
			const id = `${prefix}${linkStart + i}`;
			const exists = this.venueService.ooLinks.some((l) => l.id.toLowerCase() === id.toLowerCase());
			if (!exists) {
				newLinks.push(
					new OOLink({
						key: uuid.v4(),
						venueKey: this.venueService.venueKey,
						id: id,
						orderType: orderTypeKey || undefined,
						menuKey: menuKey || undefined,
					})
				);
			}
		}
		this.venueService.ooLinkSave(newLinks);
		this.app.msgSvc.add({ severity: "success", detail: `Added ${newLinks.length} new links` });
		this.bulkAdd = false;
	}

	printableList() {
		this.showPrintable = true;
	}
}
